import { rbac } from "config/rbac";
import { useCheckPerms } from "./useCheckPerms";

export const useIsAccountPayableUser = () =>
  useCheckPerms(rbac.manageSalesEnablementAP);
